import { createSlice } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import { DonationStatus } from '../../model'

export interface DonationState {
  donationAmount: number
  isUpdatingDonation: boolean
  isDisplayDonation: boolean
  donationStatus: DonationStatus
  hasUpdatedDonation: boolean
}

export const donationInitialState: DonationState = {
  donationAmount: 0,
  isUpdatingDonation: false,
  isDisplayDonation: false,
  donationStatus: DonationStatus.Initial,
  hasUpdatedDonation: false,
}

const slice = createSlice({
  name: 'donation',
  initialState: donationInitialState,
  reducers: {
    setDonationAmount(state, action) {
      state.donationAmount = action.payload
    },
    setIsUpdatingDonation(state, action) {
      state.isUpdatingDonation = action.payload
    },
    setIsDisplayDonation(state, action) {
      state.isDisplayDonation = action.payload
    },
    setDonationStatus(state, action) {
      state.donationStatus = action.payload
    },
    setHasUpdatedDonation(state, action) {
      state.hasUpdatedDonation = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => donationInitialState)
  },
})

export const { setDonationAmount, setIsUpdatingDonation, setIsDisplayDonation, setDonationStatus, setHasUpdatedDonation } = slice.actions

export default slice.reducer
